function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .b {\r\n        fill: #d5dc32;\r\n      }\r\n      .c {\r\n        fill: #1b325e;\r\n      }\r\n    "));

var _ref3 = /*#__PURE__*/React.createElement("polygon", {
  className: "b",
  points: "10 10 10 90 30 90 30 30 90 30 90 10 10 10"
});

var _ref4 = /*#__PURE__*/React.createElement("polygon", {
  className: "b",
  points: "50 70 30 50 40 40 50 50 80 30 90 40 50 70"
});

var SvgSafetyWiseLogoColor = function SvgSafetyWiseLogoColor(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    viewBox: "0 0 200 100",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSafetyWiseLogoColor, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/safety-wise-logo-color.39e129f4.svg";
export { ForwardRef as ReactComponent };